import SuperTokens from 'supertokens-auth-react';
import EmailPassword from 'supertokens-auth-react/recipe/emailpassword';
import Passwordless from 'supertokens-auth-react/recipe/passwordless';
import Session from 'supertokens-auth-react/recipe/session';
import ThirdParty from 'supertokens-auth-react/recipe/thirdparty';

import { ApiConstants } from '@eluve/api-contract';

export interface SuperTokensWebConfig {
  appName: string;
  websiteDomain: string;
  websiteBasePath: string;
  apiDomain: string;
  apiBasePath: string;
  /**
   * Optional session token frontend domain for cookie sharing across subdomains
   */
  sessionTokenFrontendDomain?: string;
}

/**
 * Initialize SuperTokens for web applications with standard Eluve configuration.
 *
 * This sets up:
 * - Session management
 * - Third-party login (Google) with invite code state preservation
 * - Email/Password authentication
 * - Passwordless (magic link) authentication
 */
export function initSuperTokensWeb(config: SuperTokensWebConfig): void {
  SuperTokens.init({
    appInfo: {
      appName: config.appName,
      websiteDomain: config.websiteDomain,
      websiteBasePath: config.websiteBasePath,
      apiDomain: config.apiDomain,
      apiBasePath: config.apiBasePath,
    },
    recipeList: [
      Session.init(
        config.sessionTokenFrontendDomain
          ? { sessionTokenFrontendDomain: config.sessionTokenFrontendDomain }
          : undefined,
      ),
      ThirdParty.init({
        override: {
          functions: (og) => {
            return {
              ...og,
              setStateAndOtherInfoToStorage: (input) => {
                return og.setStateAndOtherInfoToStorage({
                  state: {
                    ...input.state,
                    [ApiConstants.INVITE_CODE]:
                      input.userContext[ApiConstants.INVITE_CODE],
                  },
                  userContext: input.userContext,
                });
              },
            };
          },
        },
        signInAndUpFeature: {
          providers: [ThirdParty.Google.init()],
        },
      }),
      EmailPassword.init(),
      Passwordless.init({
        contactMethod: 'EMAIL',
      }),
    ],
  });
}
